import firebase from 'firebase'

const firebaseConfig = {
  apiKey: "AIzaSyA-0y3vGPvBHxcN5mCLafY0B4SLVMgQ8AM",
  authDomain: "facebook-clone-eac1f.firebaseapp.com",
  projectId: "facebook-clone-eac1f",
  storageBucket: "facebook-clone-eac1f.appspot.com",
  messagingSenderId: "878520861274",
  appId: "1:878520861274:web:9ff8cd8e01b8ffb575ce63",
  measurementId: "G-7NDC00BLY5"
};

const firebaseApp=firebase.initializeApp(firebaseConfig);
const db=firebaseApp.firestore();
const auth=firebase.auth();

const provider=new firebase.auth.GoogleAuthProvider();

export {auth, provider};
export default db;
